import React, { FunctionComponent, useRef } from "react";

import AnimatedNumber from "@ui/components/meta/AnimatedNumber";
import { useCommentCount } from "@ui/hooks/use-comment-count";
import { useConfigContext } from "@voxmedia/duet-context/context/config-context";

import * as styles from "./CommentCallout.css";

interface Props {
  countId: string;
}

const CommentCallout: FunctionComponent<Props> = ({ countId }) => {
  const { coralConfig } = useConfigContext();
  const containerRef = useRef<HTMLDivElement>(null);

  const { count } = useCommentCount(countId);

  if (!coralConfig) {
    throw new Error("missing coral config");
  }

  if (count === null || count < coralConfig.commentCalloutThreshold) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={`${styles.calloutContainer} ${styles.animatedContainer}`}
    >
      <span className={styles.count}>
        <AnimatedNumber number={count} />
      </span>
      <span className={styles.label}>Comments</span>
    </div>
  );
};

export default CommentCallout;
